import { itdrApi } from "./api";

class AuthActivityEvents {
  /**
   * Fetches high-level KPI summary data.
   */
  async kpiSummary() {
    try {
      // Axios uses the baseURL from your itdrApi instance
      const response = await itdrApi.get('/kpi-summary');
      
      // console.log("data: ", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch KPI summary:", error);
      throw error;
    }
  }

  /**
   * Fetches the threat timeline data.
   */
  async getThreatTimeline() {
    try {
      const response = await itdrApi.get('/threat-timeline');
      // console.log("jkaslkjasfhsjkadlsdlghsjdlajga",response.data.data);
      return response?.data;

    } catch (error) {
      console.error("Failed to fetch timeline:", error);
      // Custom error message as per your original code
      throw new Error("Failed to fetch timeline");
    }
  }

  /**
   * Fetches events related to specific actors.
   */
  async getActorEvents() {
    try {
      const response = await itdrApi.get('/actor-events');
      
      return response.data;
    } catch (error) {
      console.error("Failed to fetch actor events:", error);
      throw new Error("Failed to fetch actor events");
    }
  }
}

const authActivityEvents = new AuthActivityEvents();
export { authActivityEvents };